import { render, staticRenderFns } from "./UserStartReview.vue?vue&type=template&id=30323eea&scoped=true"
import script from "./UserStartReview.vue?vue&type=script&lang=js"
export * from "./UserStartReview.vue?vue&type=script&lang=js"
import style0 from "./UserStartReview.vue?vue&type=style&index=0&id=30323eea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30323eea",
  null
  
)

export default component.exports